import { Loader } from '@googlemaps/js-api-loader';
import { getConfigSettings } from './getConfigSettings';

export const googleMapLoader = async () => {
    const configData = await getConfigSettings({ name: ['googleMapBrowserApiKey'] })
    const googleMapAPI = configData?.googleMapBrowserApiKey
    const loader = new Loader({
        apiKey: googleMapAPI,
        libraries: ['maps', 'places', 'geometry', 'drawing', 'visualization'],
    });
    try {
        await loader.importLibrary('places');
        return new google.maps.places.AutocompleteService();
    } catch (error) {
        console.error(error);
    }
}